import { render, staticRenderFns } from "./SignupList.vue?vue&type=template&id=99b45db6&"
import script from "./SignupList.vue?vue&type=script&lang=js&"
export * from "./SignupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports